import React, { createContext, useContext } from "react";
import { observable, action, makeObservable } from "mobx";
class FeedsStore {
  feeds = [];
  feed = "";
  constructor() {
    makeObservable(this, {
      feeds: observable,
      feed: observable,
      setFeeds: action,
      setSelectedFeed: action,
    });
  }
  setFeeds(feeds) {
    this.feeds = feeds;
  }
  setSelectedFeed(feed) {
    this.feed = feed;
  }
}

const FeedsContext = createContext(null);

export const FeedsProvider = ({ children }) => {
  const store = new FeedsStore();
  return (
    <FeedsContext.Provider value={store}>{children}</FeedsContext.Provider>
  );
};

export const useFeedsStore = () => useContext(FeedsContext);